var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 25C11 25.55 10.55 26 10 26C9.45 26 9 25.55 9 25V11C9 10.45 9.45 10 10 10C10.55 10 11 10.45 11 11V25ZM17 25C17 25.55 16.55 26 16 26C15.45 26 15 25.55 15 25V11C15 10.45 15.45 10 16 10C16.55 10 17 10.45 17 11V25ZM23 25C23 25.55 22.55 26 22 26C21.45 26 21 25.55 21 25V11C21 10.45 21.45 10 22 10C22.55 10 23 10.45 23 11V25ZM21.3813 1.41L23.0562 4H29C29.55 4 30 4.4475 30 5C30 5.5525 29.55 6 29 6H28V27C28 29.7625 25.7625 32 23 32H9C6.23875 32 4 29.7625 4 27V6H3C2.44775 6 2 5.5525 2 5C2 4.4475 2.44775 4 3 4H8.94375L10.5625 1.41C11.1125 0.532875 12.075 0 13.1062 0H18.8937C19.925 0 20.8875 0.532875 21.3813 1.41ZM11.3062 4H20.6938L19.7375 2.47C19.5562 2.1775 19.2375 2 18.8937 2H13.1062C12.7625 2 12.4437 2.1775 12.2625 2.47L11.3062 4ZM6 27C6 28.6562 7.34312 30 9 30H23C24.6562 30 26 28.6562 26 27V6H6V27Z",
    fill: "#F14242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.6e91f04f3ea9122a64a0df4af7788ad7.svg";
export { ForwardRef as ReactComponent };